import React from 'react';
import { MaterialTable, SelectColumnFilter } from '../generic'
import Numeral from 'numeral'
import 'numeral/locales/en-za.js'
import { withRouter } from 'react-router-dom'

// switch between locales
Numeral.locale('en-za')

let ClientCreditLife = ({ creditLifePolicies, history }) => {

  const columns = [{
    Header: 'Policy Number',
    accessor: 'policyNumber',
    filter: 'fuzzyText'
  },
  {
    Header: 'Product Type',
    id: 'productType',
    accessor: d => (d.productType),
    Filter: SelectColumnFilter,
    filter: 'Select'
  },
  // {
  //   Header: 'Payment Type',
  //   id: 'paymentType',
  //   accessor: d => (d.paymentType),
  //   Filter: SelectColumnFilter,
  //   filter: 'Select'
  // },
  {
    Header: 'Cover Amount',
    id: 'coverAmount',
    accessor: d => Numeral(d.coverAmount).format('$ ##,###0'),
    disableFilters: true
  },
  {
    Header: 'Payment',
    id: 'payment',
    accessor: d => Numeral(d.payment).format('$ ##,###0'),
    disableFilters: true
  },
  {
    Header: 'Status',
    id: 'policyStatus',
    accessor: d => (d.policyStatus),
    Filter: SelectColumnFilter,
    filter: 'Select'
  }
  ]

  return (
    <MaterialTable columns={columns} data={creditLifePolicies} onRowPress={(row) => { console.log('credit life pressed row', row); history.push(`/credit-life/${row.id}/edit`) }} />
  )
}
ClientCreditLife = withRouter(ClientCreditLife)
export default ClientCreditLife